import { Playlist } from "@/components/playlists/Playlist";

export const PlaylistPage = () => {
  return <Playlist />;
};
